import Blue from "~/core";

new Blue({
    name: "ByLawsAndRulesTable",
    selector: ".js-byLawsAndRulesTable",
    setup(container) {
        const table = container.querySelector("table");
        const rows = [...container.querySelectorAll("tbody > tr")];
        const showMoreBtn = container.querySelector("button.byLawsAndRules-showMore");
        const initial = parseInt(container.getAttribute("data-initial-show-count"), 10);
        const step = parseInt(container.getAttribute("data-show-more-count"), 10);

        rows.forEach((row, i) => {
            if (i < initial) {
                row.classList.add("is-visible");
            }
        });
        let showing = Math.min(initial, rows.length);

        const reveal = (count) => {
            const start = table.offsetHeight;
            rows.forEach((row, i) => {
                if (i < showing + count) {
                    row.classList.add("is-visible");
                }
            });
            showing += count;
            const end = table.offsetHeight;
            table.animate(
                [{ height: `${start}px` }, { height: `${end}px` }],
                { duration: 400, easing: "ease" }
            );
            if (showing >= rows.length) {
                showMoreBtn.classList.remove("is-visible");
            }
        };

        if (rows.length > initial && showMoreBtn) {
            showMoreBtn.classList.add("is-visible");
            this.$addEvents(showMoreBtn, "click.prevent", () => reveal(step));
        }
    },
});
